import axios from "axios";

// Separate axios instance — never goes through apiClient interceptors
// This prevents refresh calls from triggering the 401 retry loop
const authAxios = axios.create({
  baseURL: (import.meta.env.VITE_API_URL as string | undefined) ?? "",
  withCredentials: true,
});

export async function refreshAccessToken(): Promise<{ accessToken: string }> {
  const res = await authAxios.post<{ accessToken: string }>("/auth/refresh");
  return res.data;
}

export async function logoutRequest(): Promise<void> {
  await authAxios.post("/auth/logout");
}
